import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Button, Table, Modal, Divider, Menu, Dropdown, Icon } from 'antd';
import moment from 'moment';
import axios from '~/axios';

export default class CourseList extends Component {
    constructor(props) {
        super(props);
        // this.showSendDialog = this.showSendDialog.bind(this);
        this.deleteCourse = this.deleteCourse.bind(this);
        this.editCourse = this.editCourse.bind(this);
    }

    // courseID: 10
    // created_at: "2019-05-10 19:09:53"
    // day: 2
    // description: null
    // siteSpecific: 0
    // targetAudience: "ALL SITES: Occupational Therapists ONLY"
    // title: "Beginner's Guide to Occupational Therapy at VCH"
    // updated_at: "2019-05-10 19:09:53"

    editCourse(courseID) {
        console.log("running editCourse function");
        console.log(this);
        const component = this;
        component.props.handleEditCourse(courseID);
    }

    deleteCourse(courseID) {
        const component = this;
        Modal.confirm({
            title: 'Delete course?',
            content: 'Are you sure you want to delete this course? This action cannot be undone.',
            okText: 'Delete Course',
            okType: 'danger',
            cancelText: 'Cancel',
            onOk() {
                console.log(component.props);
                // Deletes the selected session.
                axios.delete('/api/courses/' + courseID).then(response => {
                    console.log(response)
                    component.props.handleRemoveCourse(courseID);
                }).catch(error => {
                    console.error(error)
                });
            },
            onCancel() {
            },
        });
    }

    render() {
        const columns = [{
            title: 'Created',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (data, record) => <span>{ moment(record.created_at).format('MMMM DD YYYY') }</span>,
            sorter: (a, b) => moment(a.created_at) - moment(b.created_at)
        }, {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
            render: (data, record) => <span>{ record.title }</span>,
            sorter: (a, b) => a.title.localeCompare(b.title)
        }, {
            title: 'Target Audience',
            dataIndex: 'targetAudience',
            key: 'targetAudience',
            render: (data, record) => <span>{ record.targetAudience }</span>,
            sorter: (a, b) => a.targetAudience.localeCompare(b.targetAudience)
        },
            {
                title: 'Active',
                dataIndex: 'active',
                key: 'active',
                render: (active, record) => {
                    if (active) {
                        return <Button block
                                       onClick={ this.props.handleSetActiveCourse.bind(this, record.courseID, false) }
                                       type="primary" style={ { background: "#52C41A", borderColor: "#52C41A" } }
                                       icon="check">Active</Button>
                    } else {
                        return <Button onClick={ this.props.handleSetActiveCourse.bind(this, record.courseID, true) }><i
                            className="fe fe-send mr-2"></i>Innactive</Button>
                    }
                },
                sorter: (a, b) => a.active - b.active
            },
            {
                title: 'Actions',
                key: 'actions',
                // width: 50,
                render: (data, record) => {
                    const actionMenu = (
                        <Menu>
                            <Menu.Item key="1" onClick={ this.editCourse.bind(this, record.courseID) } icon="edit">
                                <Icon type="edit"/>Edit
                            </Menu.Item>
                            <Menu.Divider/>
                            <Menu.Item key="2" onClick={ this.deleteCourse.bind(this, record.courseID) } icon="delete"
                                       type="danger">
                                <Icon type="delete"/>Delete
                            </Menu.Item>
                        </Menu>
                    );

                    return (
                        <Dropdown overlay={ actionMenu } trigger={ ['click'] }>
                            <a className="ant-dropdown-link dashboard-action" href="#">
                                <Icon type="more"/>
                            </a>
                        </Dropdown>
                    )
                }
            }
        ];

        return <Table loading={ this.props.loading } columns={ columns } dataSource={ this.props.data }
                      rowKey='courseID' pagination={ { pageSize: 50 } } style={ { background: '#FFF' } }/>;
    }
}
